import axios from "axios";

/**
 * @description Get user students list from API /api/classroom/get-students
 * 
 * @param {Function} callbackFunction 
 * @returns {void}
 */
function APIGetStudents( callbackFunction, error_callback_function ) {
    let hostname = window.location.hostname;
    let protocol = window.location.protocol;
    let api_url = protocol + "//api." + hostname + "/api/classroom/get-students";    

    // Check if User Logged In
    if(  window.UserProfile.is_logged_in == undefined || window.UserProfile.is_logged_in == false ) {
        return;
    };

    // Get Parent Class Data
    var students_count = window.UserProfile.students_count;
    var class_id = window.UserProfile.class_id;

    if( students_count == undefined  || class_id == undefined || students_count == 0 ) {
        window.UserProfile.students = [];
        if ( 'function' == typeof callbackFunction ) {
            callbackFunction();
        }
        return
    };
    

    axios.post(
        api_url,
        {
            classId: class_id,
            groupId: class_id
        },
        {
            withCredentials: true
        }
    )
    .then( response => {
        window.UserProfile.students = [];

        // Save API Data to cookies
        response.data.data.forEach(element => {
            window.UserProfile.students.push({
                first_name: element.first_name,
                username: element.username
            });
        });
        

        // Run Callback Function
        if ( 'function' == typeof callbackFunction ) {
            callbackFunction();
        }

    } )
    .catch( ( error ) => {
        if ( "function" == typeof error_callback_function ) {
            error_callback_function();
        }
        console.log( error )
    } );
}

export { APIGetStudents };
